<template lang="pug">
.m-card
  .m-card-header(:id="'heading-fglg-' + id" :data-bs-target="'#collapse-fglg-' + id" :aria-controls="'collapse-fglg-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_FGLG", 1) }}
  .m-card-body.collapse.show(:id="'collapse-fglg-' + id" :aria-labelledby="'heading-fglg-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T
          .odds-group
            template(v-for="item in fglgo")
              template(v-if="moreItems['fglgo'][item] && moreItems['fglgo'][item][5] !=  null && moreItems['fglgo'][item][5] != 0 && moreItems['fglgo'][item][5] != ''")
                OddsItem.col-more-scroll(:odds="moreItems['fglgo'][item] " idx=5 :typ="oddsType" dataType="3" :label="$t('m.BT_' + item)")
              template(v-else)
                OddsDisabled.col-more-scroll            
        .odds-wrapper(v-if="$helpers.objSize(moreItems['fglgho']) > 0 && (mode == 0 || mode == 2)")
          .m-label-wrap
            .m-label H.T
          .odds-group
            template(v-for="item in fglgho")
              template(v-if="moreItems['fglgho'][item] && moreItems['fglgho'][item][5] !=  null && moreItems['fglgho'][item][5] != 0 && moreItems['fglgho'][item][5] != ''")
                OddsItem.col-more-scroll(:odds="moreItems['fglgho'][item] " idx=5 :typ="oddsType" dataType="3" :label="$t('m.BT_' + item)")
              template(v-else)
                OddsDisabled.col-more-scroll              
//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-fglg-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-fglg-' + id"
//-     :aria-controls="'collapse-fglg-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_FGLG", 1) }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-fglg-' + id"
//-     :id="'collapse-fglg-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         //- small.text-dark {{ $helpers.objSize(moreItems['fglgho']) > 0 && (mode == 0 || mode == 2) }}
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_HFG", 1) }}
//-               template(v-if="moreItems['fglgo']['HFG'] && moreItems['fglgo']['HFG'][5] != 0 && moreItems['fglgo']['HFG'][5] != ''")
//-                 OddsItem(:odds="moreItems['fglgo']['HFG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_HLG", 1) }}
//-               template(v-if="moreItems['fglgo']['HLG'] && moreItems['fglgo']['HLG'][5] != 0 && moreItems['fglgo']['HLG'][5] != ''")
//-                 OddsItem(:odds="moreItems['fglgo']['HLG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_AFG", 1) }}
//-               template(v-if="moreItems['fglgo']['AFG'] && moreItems['fglgo']['AFG'][5] != 0 && moreItems['fglgo']['AFG'][5] != ''")
//-                 OddsItem(:odds="moreItems['fglgo']['AFG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_ALG", 1) }}
//-               template(v-if="moreItems['fglgo']['ALG'] && moreItems['fglgo']['ALG'][5] != 0 && moreItems['fglgo']['ALG'][5] != ''")
//-                 OddsItem(:odds="moreItems['fglgo']['ALG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_NG", 1) }}
//-               template(v-if="moreItems['fglgo']['NG'] && moreItems['fglgo']['NG'][5] != 0 && moreItems['fglgo']['NG'][5] != ''")
//-                 OddsItem(:odds="moreItems['fglgo']['NG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-         .normal(v-if="$helpers.objSize(moreItems['fglgho']) > 0 && (mode == 0 || mode == 2)")
//-           .normal-title {{ $t("ui.half_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_HFG", 1) }}
//-               template(v-if="moreItems['fglgho']['HFG'] && moreItems['fglgho']['HFG'][5] != 0 && moreItems['fglgho']['HFG'][5] != ''")
//-                 OddsItem(:odds="moreItems['fglgho']['HFG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_HLG", 1) }}
//-               template(v-if="moreItems['fglgho']['HLG'] && moreItems['fglgho']['HLG'][5] != 0 && moreItems['fglgho']['HLG'][5] != ''")
//-                 OddsItem(:odds="moreItems['fglgho']['HLG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_AFG", 1) }}
//-               template(v-if="moreItems['fglgho']['AFG'] && moreItems['fglgho']['AFG'][5] != 0 && moreItems['fglgho']['AFG'][5] != ''")
//-                 OddsItem(:odds="moreItems['fglgho']['AFG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_ALG", 1) }}
//-               template(v-if="moreItems['fglgho']['ALG'] && moreItems['fglgho']['ALG'][5] != 0 && moreItems['fglgho']['ALG'][5] != ''")
//-                 OddsItem(:odds="moreItems['fglgho']['ALG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_NG", 1) }}
//-               template(v-if="moreItems['fglgho']['NG'] && moreItems['fglgho']['NG'][5] != 0 && moreItems['fglgho']['NG'][5] != ''")
//-                 OddsItem(:odds="moreItems['fglgho']['NG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      fglgo: ["HFG", "HLG", "AFG", "ALG", "NG"],
      fglgho: ["HFG", "HLG", "AFG", "ALG", "NG"]
    }
  }
}
</script>
